class EventGenerator {
  constructor(){
    this.listeners = {};
  }

  on(eventName, listener){
    if(!this.listeners[eventName]){
      this.listeners[eventName] = [];
    }

    this.listeners[eventName].push(listener);
  }

  off(eventName, listener){
    if(this.listeners[eventName]){
      this.listeners[eventName] = this.listeners[eventName]
        .filter(l => l !== listener);
    }
  }

  _sendEvent(eventName, event){
    if(this.listeners[eventName]){
      this.listeners[eventName].forEach(listener=> listener(event));
    }
  }
}

var toExport = {
  EventGenerator
};

if(typeof module !== "undefined" && typeof module.exports !== "undefined"){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}



/** WEBPACK FOOTER **
 ** ./src/components/eventGenerator.js
 **/